export const EMAIL_SEND_STATUS_OPTIONS = [
	{ value: 'scheduled', label: 'Geplant' },
	{ value: 'sent', label: 'Gesendet' },
	{ value: 'failed', label: 'Fehlgeschlagen' },
	{ value: 'skipped', label: 'Übersprungen' },
];

export const EMAIL_SEND_FILTER_SCHEMA = {
	status: { type: 'enumList', label: 'Status', options: EMAIL_SEND_STATUS_OPTIONS },
	opened: { type: 'yesNo', label: 'Geöffnet' },
	clicked: { type: 'yesNo', label: 'Geklickt' },
	unsubscribed: { type: 'yesNo', label: 'Abgemeldet' },
	search: { type: 'string', label: 'Suche' },
};

export const EMAIL_SENDS_URL_NAMESPACE = 'sends';
